import { CUSTOMER_PASSWORD_MIN_LENGTH } from "@cem/contracts";
import { useEffect, useState } from "react";
import { api } from "./api.js";
import "./accounts.css";

export function AccountRecoveryPage({
  returnHref = "/",
}: {
  returnHref?: string;
}) {
  const [initial] = useState(() => {
    const data = new URLSearchParams(window.location.hash.slice(1));
    const token = data.get("token") ?? "",
      purpose = data.get("purpose") ?? "reset";
    return { token, purpose };
  });
  useEffect(() => {
    // The initializer must remain pure under React StrictMode double rendering.
    window.history.replaceState(null, "", window.location.pathname);
    const policy = document.createElement("meta");
    policy.name = "referrer";
    policy.content = "no-referrer";
    document.head.append(policy);
    return () => policy.remove();
  }, []);
  const [email, setEmail] = useState(""),
    [kind, setKind] = useState<"reset" | "username">("reset");
  const [password, setPassword] = useState(""),
    [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false),
    [message, setMessage] = useState(""),
    [error, setError] = useState(""),
    [done, setDone] = useState(false);
  return (
    <main className="login-page">
      <section className="login-panel">
        <img className="login-logo" src="/cem-logo.png" alt="CEM" />
        <h1>
          {initial.token
            ? initial.purpose === "verify"
              ? "Verifica email"
              : "Imposta password"
            : "Recupera accesso"}
        </h1>
        <p>
          Account del gestionale CEM. L’area personale riservata resta separata.
        </p>
        {!done && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              void (async () => {
                setError("");
                setMessage("");
                setBusy(true);
                try {
                  if (
                    initial.token &&
                    initial.purpose !== "verify" &&
                    password !== confirm
                  )
                    throw new Error("Le password non coincidono.");
                  const result = initial.token
                    ? await api.post<{ message: string }>(
                        initial.purpose !== "verify" && password.length < 12
                          ? "/api/v1/customer-auth/recovery/complete"
                          : "/api/v1/auth/recovery/complete",
                        {
                          token: initial.token,
                          purpose: initial.purpose,
                          ...(initial.purpose === "verify" ? {} : { password }),
                        },
                      )
                    : await api.post<{ message: string }>(
                        "/api/v1/auth/recovery/request",
                        { email, kind },
                      );
                  setMessage(result.message);
                  setDone(!!initial.token);
                  setPassword("");
                  setConfirm("");
                } catch (cause) {
                  setError(
                    cause instanceof Error
                      ? cause.message
                      : "Operazione non riuscita.",
                  );
                } finally {
                  setBusy(false);
                }
              })();
            }}
          >
            {!initial.token ? (
              <>
                <label>
                  Cosa hai dimenticato?
                  <select
                    value={kind}
                    onChange={(e) =>
                      setKind(e.target.value as "reset" | "username")
                    }
                  >
                    <option value="reset">Password</option>
                    <option value="username">Nome utente</option>
                  </select>
                </label>
                <label>
                  Email associata all’account
                  <input
                    type="email"
                    required
                    autoComplete="email"
                    maxLength={254}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>
              </>
            ) : initial.purpose === "verify" ? (
              <p>
                Conferma per verificare l’indirizzo. La sola apertura del
                collegamento non modifica l’account.
              </p>
            ) : (
              <>
                <label>
                  Nuova password
                  <input
                    type="password"
                    autoComplete="new-password"
                    required
                    minLength={CUSTOMER_PASSWORD_MIN_LENGTH}
                    maxLength={1024}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </label>
                <label>
                  Conferma password
                  <input
                    type="password"
                    autoComplete="new-password"
                    required
                    minLength={CUSTOMER_PASSWORD_MIN_LENGTH}
                    maxLength={1024}
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                  />
                </label>
              </>
            )}
            <button className="primary-button" disabled={busy}>
              {busy
                ? "Attendere…"
                : initial.token
                  ? "Conferma"
                  : "Invia istruzioni"}
            </button>
          </form>
        )}
        {message && <p role="status">{message}</p>}
        {error && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}
        <p>
          <a href={returnHref}>Torna all’accesso</a>
        </p>
        <p>
          Non hai più accesso alla tua email? Contatta un amministratore per la
          verifica dell’identità. La password precedente non può essere
          recuperata o mostrata.
        </p>
      </section>
    </main>
  );
}
